/** 
 * @type {import("./defs").StoreInvestorAccount} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreInvestorAccount} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreInvestorAccount.js